import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { DataService } from './../../../admin/system-log-manager/data.service';
import { Location } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-system-log-type-data-sectors',
  templateUrl: './system-log-type-data-sectors.component.html',
  styleUrls: ['./system-log-type-data-sectors.component.scss']
})
export class SystemLogTypeDataSectorsComponent implements OnInit {

  
   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

// public logs$: Observable<SystemLog[]>;
  // Normal Layout
  logs$: Observable<any>;
  logs: any;

  // for grid so it has change events.
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  @ViewChild('grid')
  public grid: GridComponent;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;

  // @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

   // Function below pushes form to allRecipients array, and closes window.
   @Output('addRecipientFromModal') addRecipientFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationFromModal') addAutomationFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addConditionFromModal') addConditionFromModal: EventEmitter<any> = new EventEmitter();

     job_types: any;
     job_types_tree: any;
      jobTypesTreeObject: { dataSource: any; id: string; parentID: string; text: string; hasChildren: string; };


 
  job_type_locations: Object;
  job_type_courts: Object;
  job_type_document_types: Object;
  job_type_affidavit_types: Object;
  collection: any;
  addTypeClick: boolean;
  updateTypeClick: boolean;
  initialCount = 0; // Put this in the master -> for child component
  public count;
  currentUserVAR: any;
  sessionUserName: any;
  sessionUserId: any;
  sessionBrandId: any;
  nav: any;
  modalRef: any;
  system_log_types: Object;
  get_latest_system_log_type_id: Object;
  system_log_type_data_sector_conditions: Object;
  get_latest_system_log_type_data_sector_condition_id: Object;
  system_log_type_data_sectors: Object;
  get_latest_type_data_sector_id: Object;
  // maps the appropriate column to fields property
  // public field_data_object: Object = {
  //   dataSource: this.localData,
  //    id: 'id',
  //    parentID: 'pid',
  //    text: 'name',
  //    hasChildren: 'hasChild' };


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService
     
  ) {
    this.nav = document.querySelector('nav.navbar');
   

  // login vars
  this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  // Set loggind in User Value (USER ID)
  this.sessionUserId = this.currentUserVAR.user_id;
  this.sessionUserName = this.currentUserVAR.username;
  this.sessionBrandId = this.currentUserVAR.brand_id;


   }


  ngOnInit() {


    // this.getSystemLogTypeDataSectorConditions();
    this.getSystemLogTypeDataSectors();

    // :: show hide update and ceate components
    this.addTypeClick = false;
    this.updateTypeClick = false;


// Setup Grid
this.toolbarOptions = ['Search'];
// this.toolbarOptions = ['ExcelExport', 'Search'];
// this.toolbar = [
// { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

//  this.initialPage = { pageSize: 100 };
this.filterOptions = {
  type: 'Menu'
};
this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
this.dateFormat = 'dd/MM/yyyy hh:mm a';
this.filter = { params: { format: this.dateFormat } };


}
// end onint



  getJobTypesTree() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types_tree = data; },
       err => console.error(err),
        () => {
          console.log('done loading Trace Types');
                      }
          );
   }
// end getTree



getSystemLogTypes() {
  this._demoService.getSystemLogTypes().subscribe(
     data => { this.system_log_types = data;  },
     err => console.error(err),
      () => {
        console.log('done loading System Log Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }

 getSystemLogTypeDataSectorConditions() {
  this._demoService.getSystemLogTypeDataSectorConditions().subscribe(
     data => { this.system_log_type_data_sector_conditions = data;  },
     err => console.error(err),
      () => {
        console.log('done loading System Log Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }



 
 getSystemLogTypeDataSectors() {
  this._demoService.getSystemLogTypeDataSectors().subscribe(
     data => { this.system_log_type_data_sectors = data;  },
     err => console.error(err),
      () => {
        console.log('done loading System Log Type Data Sectors')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }

getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data;  },
     err => console.error(err),
      () => {
        console.log('done loading Trace Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }


 sendTypeID(id) {
  // this.initialCount = this.trace_candidates.trace_candidate_id;
  this.count = id;
  this.initialCount = id;
// console.log('sending ID:' + this.count);

}

 getJobTypeAllLocations() {
  this._demoService.getJobTypeAllLocations().subscribe(
     data => { this.job_type_locations = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 deleteJobType(job_type_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    this._demoService.deleteJobType(job_type_id).subscribe(
       data => {
         // refresh the list
         this.toastr.warning("Data Object Deleted!")
         this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting!');
        return console.log(error);
       }
    );
}
};



deleteSystemLogType(log_type_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    this._demoService.deleteSystemLogType(log_type_id).subscribe(
       data => {
         // refresh the list
         this.toastr.warning("Data Object Deleted!")
         this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting!');
        return console.log(error);
       }
    );
}
};


deleteSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    this._demoService.deleteSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id).subscribe(
       data => {
         // refresh the list
         this.toastr.warning("Data Object Deleted!")
         this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting!');
        return console.log(error);
       }
    );
}
};


deleteSystemLogTypeDataSector(log_type_data_sector_id) {
  if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
    this._demoService.deleteSystemLogTypeDataSector(log_type_data_sector_id).subscribe(
       data => {
         // refresh the list
         this.toastr.success("Data Object Deleted!")
         this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting!');
        return console.log(error);
       }
    );
}
};



 getJobTypeAllCourts() {
  this._demoService.getJobTypeAllCourts().subscribe(
     data => { this.job_type_courts = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeAllDocumentTypes() {
  this._demoService.getJobTypeAllDocumentTypes().subscribe(
     data => { this.job_type_document_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeAllAffidavitTypes() {
  this._demoService.getJobTypeAllAffidavitTypes().subscribe(
     data => { this.job_type_affidavit_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}

// // :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


refreshGrid() { // refresh the databutton
  // this.getFiles();
  this.getSystemLogTypeDataSectors();
  this.grid.refresh();
};
   // to router navigate back
   public goBack() {
    this._location.back();
    }

viewJobTypeLocations(job_type_id){
  this.router.navigate(['/admin/system-settings/job-types/locations/' + job_type_id + '']);
}



makeDuplicateSystemLogType(model){
  if (confirm('We are about duplicate this System Log Type Trigger, Are you Sure this also needs to be hard coded into system to function... see developer first!!!!?')) {
  // post a new With this model. & Name as copuy
  model.log_type_name =  model.log_type_name + '_COPY'
  model.log_type_description = '_COPY **** of **** ' + model.log_type_description
  // model.doc_notes = '_COPY **** of **** ' + model.doc_notes
  // model.is_active = '';
  // model.templates_created_tested = '';
  this.createSystemLogType(model);
  }
}


makeDuplicateSystemLogTypeDataSectorCondition(model){
  if (confirm('We are about duplicate this System Log Type Data Sector Condition')) {
  // post a new With this model. & Name as copuy
  model.log_type_data_sector_condition_name =  model.log_type_data_sector_condition_name + '_COPY'
  model.log_type_data_sector_condition_description = '_COPY **** of **** ' + model.log_type_data_sector_condition_description
  // model.doc_notes = '_COPY **** of **** ' + model.doc_notes
  model.is_active = '1';
  // model.templates_created_tested = '';
  this.createSystemLogTypeDataSectorCondition(model);
  }
}



makeDuplicateSystemLogTypeDataSector(model){
  if (confirm('We are about duplicate this System Log Type Data Sector')) {
  // post a new With this model. & Name as copuy
  model.log_type_data_sector_name =  model.log_type_data_sector_name + '_COPY'
  model.log_type_data_sector_description = '_COPY **** of **** ' + model.log_type_data_sector_description
  // model.doc_notes = '_COPY **** of **** ' + model.doc_notes
  model.is_active = '';
  // model.templates_created_tested = '';
  this.createSystemLogTypeDataSector(model);
  }
}



createSystemLogTypeDataSector(model) {
  // console.log(model);
      this._demoService.createSystemLogTypeDataSector(model).subscribe(
            data => {  this.get_latest_type_data_sector_id = data; // this is the retuned json upon creation.
            this.toastr.success('Log Type Data Sector Created');
            // this.closeParentModel.emit();
            this.gfunc.globalViewSystemLogTypeDataSectorsSkipRoute();
  // CreateJobTypeComponent.returned.next(false);
              //  return true;
            },
            error => {
              this.toastr.error('Adding Log Type Data Sector Failed :: Please try again!');
              // console.log(Observable.throw(error));
              // return Observable.throw(error);
            }
      );
      }

createSystemLogTypeDataSectorCondition(model) {
  // console.log(model);
      this._demoService.createSystemLogTypeDataSectorCondition(model).subscribe(
           data => {  this.get_latest_system_log_type_data_sector_condition_id = data; // this is the retuned json upon creation.
           this.toastr.success('Log Type Data Sector Condition Created');
          //  this.closeParentModel.emit();
           this.gfunc.globalViewSystemLogTypeDataSectorConditionsSkipRoute();
 // CreateJobTypeComponent.returned.next(false);
             //  return true;
           },
           error => {
             this.toastr.error('Adding Log Type Data Sector Condition Failed :: Please try again!');
             // console.log(Observable.throw(error));
             // return Observable.throw(error);
           }
      );
      }

createSystemLogType(model) {
  // console.log(model);
      this._demoService.createSystemLogType(model).subscribe(
           data => {  this.get_latest_system_log_type_id = data; // this is the retuned json upon creation.
           this.toastr.success('Log Type Created');
          //  this.closeParentModel.emit();
           this.gfunc.globalViewSystemLogTypesSkipRoute();
 // CreateJobTypeComponent.returned.next(false);
             //  return true;
           },
           error => {
             this.toastr.error('Adding Job Type Failed :: Please try again!');
             // console.log(Observable.throw(error));
             // return Observable.throw(error);
           }
      );
      }


}


